import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import "./styles.scss";
import "./mobile.scss";
import {Button, DatePickerComponent, DetailsNotFound, NewsGroup, PageNavigation, TopMenu,} from "../../components";
import {getLanguage} from "../../utils/environment";
import {withRouter} from "react-router-dom/cjs/react-router-dom.min";
import {useDispatch, useSelector} from "react-redux";
import {Helmet} from "react-helmet";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  HomePageCenterAdd,
  NewsViewLeftBottomAdd,
  NewsViewRightTopAdd,
} from "../templates/advertiesments";
import Footer from "../footer/index";
import HotNewsSmall from "../templates/hotNewsSmall";
import {AdvertisementModal, HomeAdViewModal, MobileMenuModal} from "../modal";
import Menu from "../templates/menu";
import {GetIconByName} from "../../config/icon";
import {downloadJobApplication, getAllJobsCategory,} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import {getInsight, setInsight} from "../../utils";
import {setGazetteList, setJobCategoryList} from "../Jobs/redux/actions";
import {createNewInsight} from "../console/services/insight.service";
import {addNewGazetteImpression, addNewJobsDownloadImpression,} from "../GovernmentJobsPage/service/jobs.service";
import {getIPAddress} from "../../utils/browserMeta";
import {getAllGazette} from "../CreateNewItem/CreateNewGazette/service/jobs.service";
import GazetteViewCard from "../../components/gazetteViewCard";
import moment from "moment";
import {openHomeAdModal} from "../console/redux/actions";

const lan = getLanguage();

const Index = (props) => {
  const [category, setCategory] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [jobId, setJobId] = useState("");
  const [selectGazette, setSelectGazette] = useState("");
  const [jobDetails, setJobDetails] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10);
  const [isOpenAdvertisementModal, setIsOpenAdvertisementModal] =
    useState(false);

  const dispatch = useDispatch();
  const { isOpenMobileMenuModal, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer,
  );
  const { jobCategoryList } = useSelector(({ jobsReducer }) => jobsReducer);

  const gazetteList = useSelector((state) => state.jobsReducer.gazetteList);
  const { datePickData } = useSelector(({ datePicker }) => datePicker);

  const [formData, setFormData] = useState({
    gazetteDate: {
      key: "gazetteDate",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "YYYY-MM-DD",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-2",
    },
  });

  const [filteredGazetteList, setFilteredGazetteList] = useState(
    gazetteList || [],
  );

  async function handleInsight(gazetteId) {
    let insightBody = {};
    try {
      console.log({ gazetteId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://sinhala.hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      const insight = await getInsight();
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          gazette_id: gazetteId,
          ip_address: ip,
        };

        let resImpression = await addNewGazetteImpression(impressionBody);
        console.log("addNew_gazette_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            gazette_id: gazetteId,
            ip_address: insightBody.ip,
          };

          let resImpression = await addNewGazetteImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const getList = await getAllGazette();
      console.log("Get All Gazette : ", getList);
      setIsLoading(false);

      if (getList.data) {
        setFilteredGazetteList(getList.data);
        dispatch(setGazetteList(getList.data));
        await handleInsight(getList?.data?.gazette_id);
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Campaign Data", error);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // setIsOpenAdvertisementModal(false);
    fetchData();
    dispatch(openHomeAdModal());
    // Check if cookie already exists
    // const promoCookie = getCookie("popup");

    // if (!promoCookie) {
    //   // No cookie => show modal + set cookie
    //   // dispatch(openHomeAdModal());

    //   // Set cookie that expires in 1 day (24h)
    //   setCookie("popup", "POPUP_ADVERTISEMENT", { days: 1 });
    // }
    setIsOpenAdvertisementModal(true);
  }, []);

  async function handleInsightDownload(jobId, categoryId) {
    let insightBody = {};
    try {
      console.log({ jobId, categoryId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      console.log("userInsight_insightBody:", insightBody);
      const insight = await getInsight();
      console.log("Insight found", insight);
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          job_id: jobId,
          category_id: categoryId,
          ip_address: ip,
        };

        let resImpression = await addNewJobsDownloadImpression(impressionBody);
        console.log("addNew_Job_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            job_id: jobId,
            category_id: categoryId,
            ip_address: insightBody.ip,
          };

          let resImpression =
            await addNewJobsDownloadImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    setCategory(childData);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      console.log(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const openWindow = (imgUrl) => {
  //   const newWindow = window.open("", "", "width=1024,height=920");
  //   if (newWindow) {
  //     newWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>New Window</title>
  //       </head>
  //       <body style="margin:0; padding:0; display:flex; justify-content:center; align-items:center; height:100vh;">
  //       <div>
  //         <div className={"cw__advertiesment-wrapper"}>
  //           <div className="top-ad active">
  //
  //           </div>
  //           <div className="top-ad active">
  //
  //           </div>
  //         </div>
  //         <img src="${imgUrl}" alt="job details sinhala" style="max-width:100%; max-height:100%;" />
  //       </div>
  //       </body>
  //     </html>
  //   `);
  //     newWindow.document.close();
  //   }
  // };

  const openWindow = async (imgUrl, gazette_id) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight(); // Assuming this returns { insight_id }
    try {
      await handleInsight(gazette_id);
    } catch (error) {
      console.log(error);
    }

    // const isPdf = imgUrl.endsWith(".pdf");
    let previewElement = "";
    console.log("Array.isArray(imgUrl)", Array.isArray(imgUrl));
    if (Array.isArray(imgUrl)) {
      previewElement = imgUrl
        .map((img, id) => {
          const src = img?.file_url;
          if (src?.endsWith(".pdf")) {
            return `<iframe src="${src}" alt="${id}" class="responsive-content"></iframe>`;
          } else {
            return `<img src="${src}" alt="${id}" class="responsive-content" />`;
          }
        })
        .join("");
    } else {
      previewElement = imgUrl?.endsWith(".pdf")
        ? `<iframe src="${imgUrl}" alt="PDF" class="responsive-content"></iframe>`
        : `<img src="${imgUrl}" alt="job details sinhala" class="responsive-content" />`;
    }

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
    <html>
      <head>
        <title>Preview</title>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
          }

          .advertisement-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: center;
            gap: 10px;
            height: 80px;
            flex-shrink: 0;
          }

          .top-ad {
            flex: 1;
            height: 100%;
          }

          .top-ad iframe {
            width: 100%;
            height: 100%;
            border: none;
          }

          .content-container {
            flex: 1;
            /*overflow: auto;*/
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f8f8f8;
          }

          .responsive-content {
            max-width: 100%;
            max-height: 100%;
            width: 100%;
            height: 100%;
            object-fit: contain;
            border: none;
          }
        </style>
      </head>
      <body>
        <div class="advertisement-wrapper">
          <div class="top-ad">
            <iframe id="adFrameLeft" src="${safeAdUrlLeft}" loading="lazy"></iframe>
          </div>
          <div class="top-ad">
            <iframe id="adFrameRight" src="${safeAdUrlRight}" loading="lazy"></iframe>
          </div>
        </div>
        <div class="content-container"  style="display: flex; flex-direction: column;">
          ${previewElement}
        </div>
        <script>
          window.addEventListener('load', function () {
            const iframeLeft = document.getElementById('adFrameLeft');
            const iframeRight = document.getElementById('adFrameRight');

            iframeLeft?.addEventListener('load', function () {
              iframeLeft.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlLeft}"
              );
            });

            iframeRight?.addEventListener('load', function () {
              iframeRight.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlRight}"
              );
            });
          });
        </script>
      </body>
    </html>
  `);
      newWindow.document.close();
    }
  };

  const onClickDownloadApplication = async (job_id, lan) => {
    setIsLoading(true);
    try {
      if (jobDetails?.job_application?.[`${lan}_url`]?.endsWith(".pdf")) {
        const url = jobDetails?.job_application?.[`${lan}_url`];

        if (url.endsWith(".pdf")) {
          window.open(url, "_blank");
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = `job_${job_id}_${lan}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setIsLoading(false);
      } else {
        let response = await downloadJobApplication(job_id, lan);
        console.log("response download::", response);
        if (response?.data) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `job_${job_id}_${lan}.pdf`; // Optional: Make dynamic with job_id
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          alert("Downloaded");
          setIsLoading(false);
          window.scrollTo(0, 0);
        }
      }

      await handleInsightDownload(job_id, jobDetails?.organization);

      // setIsLoading(false);
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      // setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0) {
      fetchCategories();
    }
  }, []);

  const handleFindGazette = async () => {
    const dateValue = formData.gazetteDate.value;

    if (!dateValue || dateValue === "") {
      // setFilteredGazetteList(gazetteList);
      await fetchData();
      return;
    }
    const formattedDate = dayjs(dateValue).format("YYYY-MM-DD");

    const filtered = gazetteList.filter(
      (g) => dayjs(g.gazette_date).format("YYYY-MM-DD") === formattedDate,
    );
    console.log({ filtered });

    setFilteredGazetteList(filtered);
  };

  useEffect(() => {
    if (datePickData) {
      if (datePickData?.date === "") {
        fetchData();
      }
      const updatedForm = { ...formData };
      console.log({ datePickData });
      updatedForm.gazetteDate.value = datePickData.date;
      setFormData(updatedForm);
    }
  }, [datePickData]);

  const updateForm = { ...formData };

  return (
    <>
      <Helmet>
        <title>{jobDetails?.job_title?.[lan] || "Government Gazette"}</title>
        <meta
          name="description"
          content={
            jobDetails?.summary?.[lan]?.slice(0, 150) || "Government Gazette."
          }
        />
        <meta property="og:title" content={jobDetails?.job_title?.[lan]} />
        <meta
          property="og:description"
          content={jobDetails?.description?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={jobDetails?.banner_img?.file_url} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: jobDetails?.job_title?.[lan],
            image: [jobDetails?.banner_img?.file_url],
            datePublished: jobDetails?.created_at,
            dateModified: jobDetails?.updated_at || jobDetails?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        {isOpenMobileMenuModal && <MobileMenuModal/>}
        {isOpenAd && <HomeAdViewModal/>}
        {isOpenAdvertisementModal && <AdvertisementModal/>}
        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""} `}>
            <div className={"cwt__hope"}>
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={jobDetails?.job_title?.[lan]}
              />
            </div>
            <div className={"menu"}>
              <Menu setMenuName={handleChildData} />
            </div>

            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            >
              {GetIconByName("menu")}
            </div> */}
          </div>
          <div className={"cw__advertiesment-wrapper"}>
            <ConsoleTopLeftAdd />
            <ConsoleTopRightAdd />
          </div>

          <div className="gov-date-filter">
            <PageNavigation
              data={{
                main: "Gazette",
                page: "All",
              }}
              // onClick={() => props.history.push("/gov-jobs")}
            />
            <div className="gdf-left-wrapper">
              <div style={{ width: "200px" }}>
                <DatePickerComponent data={updateForm?.gazetteDate} />
              </div>

              <Button
                data={{
                  btnName: "Find Gazette",
                  buttonType: "black-border",
                  buttonSize: "xs-x",
                  // isLoading: isLoading,
                }}
                onClick={async () => {
                  await handleFindGazette();
                }}
              />
            </div>
          </div>

          <div className={`gov-gazette-view-wrapper`}>
            <div className={"gj__special-news-group"}>
              <NewsGroup
                data={{
                  titleName: "Gazette",
                  // linkName: "තවත් පුවත්",
                  // linkName: (
                  //   <>
                  //     {pageCount > news?.length && (
                  //       <div
                  //         className={
                  //           "d-flex flex-column justify-content-center align-items-center mt-5"
                  //         }
                  //       >
                  //         <Pagination
                  //           data={{
                  //             paginationCount: pageCount,
                  //             pageNo: pageNo,
                  //           }}
                  //           onChange={onChangePage}
                  //         />
                  //       </div>
                  //     )}
                  //   </>
                  // ),
                }}
                // onClickViewNews={() => {
                //   onChangePage(pageNo + 1);
                // }}
              >
                <div className="pl-3 pr-3">
                  {gazetteList.length > 0 ? (
                    [...gazetteList]
                      .sort(
                        (a, b) =>
                          new Date(b.gazette_date).getTime() -
                          new Date(a.gazette_date).getTime(),
                      )
                      .slice(0, visibleCount)
                      .map((gazette) => (
                        <GazetteViewCard
                          // key={gazette?.gazette_id}
                          isSelect={selectGazette === gazette?.gazette_id}
                          titleEn={
                            "Gazette of the Democratic Socialist Republic of Sri Lanka"
                          }
                          titleSi={
                            "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජයේ ගැසට් පත්‍ර"
                          }
                          gazetteDate={gazette?.gazette_date}
                          created_at={gazette?.created_at}
                          organization={gazette?.tags}
                          views={gazette?.views || 0}
                          isArrow={true}
                          onClickView={() => {
                            // dispatch(setGazette(gazette));
                            setSelectGazette(gazette?.gazette_id);
                            // props.history.push("/gazette-view");

                            props.history.push(
                              `/government-gazette/${moment(
                                gazette?.gazette_date,
                              ).format("YYYY-MM-DD")}/${gazette?.gazette_id}`,
                            );
                          }}
                          // job_si={gazette?.job_details?.si_url}
                          // job_en={gazette?.job_details?.en_url}
                          // job_ta={gazette?.job_details?.ta_url}
                          // onClickDetailsSI={async () => {
                          //   await openWindow(
                          //     gazette?.job_details?.si_url,
                          //     gazette?.gazette_id
                          //   );
                          // }}
                          // onClickDetailsEN={async () => {
                          //   await openWindow(
                          //     gazette?.job_details?.en_url,
                          //     gazette?.gazette_id
                          //   );
                          // }}
                          // onClickDetailsTA={async () => {
                          //   await openWindow(
                          //     gazette?.job_details?.ta_url,
                          //     gazette?.gazette_id
                          //   );
                          // }}
                        />
                      ))
                  ) : (
                    <div className="error-message-wrapper">
                      <DetailsNotFound
                        title={"Gazette Details Not Found"}
                        subTitle={
                          "We couldn't locate the gazette you're looking for It might be unpublished, removed"
                        }
                        onClickRefresh={fetchData}
                      />
                    </div>
                  )}
                  {/* Fade-out effect (only when collapsed) */}
                  {gazetteList.length > 10 &&
                    visibleCount < gazetteList.length && (
                      <div
                        style={{
                          height: "50px",
                          background:
                            "linear-gradient(to bottom, rgba(255,255,255,0), white)",
                          marginTop: "-50px",
                          zIndex: 1,
                        }}
                      />
                    )}

                  {/* Show More / Show Less Button */}
                  {gazetteList.length > 10 && (
                    <div
                      className="loading-more"
                      style={{ marginTop: "5px", marginBottom: "20px" }}
                    >
                      <Button
                        data={{
                          btnName:
                            visibleCount >= gazetteList.length
                              ? "Show Less"
                              : "Show More..",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: isLoading,
                          btnIcon: GetIconByName(
                            visibleCount >= gazetteList.length
                              ? "arrow-up"
                              : "arrow-down",
                          ),
                        }}
                        onClick={() => {
                          setVisibleCount((prev) => {
                            if (prev >= gazetteList.length) {
                              // Reset to first 4 and scroll to top smoothly
                              window.scrollTo({ top: 0, behavior: "smooth" });
                              return 10;
                            }
                            return Math.min(prev + 10, gazetteList.length);
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </NewsGroup>

              <div className="bottom-ad">
                <NewsViewLeftBottomAdd />
              </div>
              <div className="bottom-ad-mobile">
                <HomePageCenterAdd />
              </div>
            </div>

            <div className={"gj__special-news-group"}>
              <NewsViewRightTopAdd data={{ mainLayerStyles: "mb-3" }} />
              <HotNewsSmall setMenuName={handleChildData} />
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};


export default withRouter(Index);
